import type { SxProps, Theme } from "@mui/material/styles";
import { BACKGROUND_DARK } from "../../theme/consts";
import { generalSectionSx } from "../Layout";

// Main container - full viewport height
// Negative margin creates overlap with previous section (NextSteps) for smooth transition
export const scrollContainerSx: SxProps<Theme> = {
  minHeight: "100svh",
  height: "auto",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  background: BACKGROUND_DARK,
  marginTop: { xs: "-15svh", md: "-5svh", "2xl": "-20svh" },
};

// Content container - centers the form content
export const sectionContainerSx: SxProps<Theme> = {
  flex: 1,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...generalSectionSx,
};
